import { Injectable } from '@angular/core';
import { AppCommunicationService } from './app-communication.service';
import {
  generatePromoCodesForSchoolsUrl, generatePromoCodesForUsersByFilterUrl, generatePromoCodesForUsersUrl,
  generatePromoCodesOriginalityUrl, getAllPromocodesByFilterUrl, getAllThesisOrdersByFilterUrl, getDeletePromocodeUrl,
  getThesisOrderByFilterUrl, getThesisOrderSendProtocolUrl,
  getThesisOrderStatusUrl,
} from '../app.urls';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PromocodeModel } from '../models/promocode/promocode.model';
import { PromocodePrivateEmailModel } from '../models/promocode/promocode-private-email.model';
import { PromocodePrivateFilterModel } from '../models/promocode/promocode-private-filter.model';

@Injectable()
export class OriginalityService {

  constructor(private httpClient: HttpClient) {
  }

  generatePromoCodeForSchool(promocode: PromocodeModel): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${AppCommunicationService.getCurrentUser().access_token}`,
      }),
    };

    return this.httpClient
      .post(generatePromoCodesForSchoolsUrl(), promocode, httpOptions)
      .pipe(map((res: any) => {
        return res;
      }));
  }

  generatePromoCodeForUser(promocode: PromocodePrivateEmailModel): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${AppCommunicationService.getCurrentUser().access_token}`,
      }),
    };

    return this.httpClient
      .post(generatePromoCodesForUsersUrl(), promocode, httpOptions)
      .pipe(map((res: any) => {
        return res;
      }));
  }

  generatePromoCodeForUserByFilter(promocode: PromocodePrivateFilterModel): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${AppCommunicationService.getCurrentUser().access_token}`,
      }),
    };

    return this.httpClient
      .post(generatePromoCodesForUsersByFilterUrl(), promocode, httpOptions)
      .pipe(map((res: any) => {
        return res;
      }));
  }

  generatePromoCodes(count: number): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${AppCommunicationService.getCurrentUser().access_token}`,
        'Content-Type': `application/x-www-form-urlencoded`,
      }),
    };

    return this.httpClient
      .post(generatePromoCodesOriginalityUrl(count), {}, httpOptions)
      .pipe(map((res: any) => {
        return res;
      }));
  }

  getStatusByOrderId(orderId: number): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${AppCommunicationService.getCurrentUser().access_token}`,
        'Content-Type': `application/x-www-form-urlencoded`,
      }),
    };

    return this.httpClient
      .get(getThesisOrderStatusUrl(orderId), httpOptions)
      .pipe((res: any) => {
        return res;
      }, catchError(e => {
        return throwError(e);
      }));
  }

  getOriginalityDataByFilter(filter: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${AppCommunicationService.getCurrentUser().access_token}`
      }),
    };

    return this.httpClient
      .post(getThesisOrderByFilterUrl(), filter, httpOptions)
      .pipe((res: any) => res);
  }

  getAllPromocodesByFilter(filter: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${AppCommunicationService.getCurrentUser().access_token}`
      }),
    };

    return this.httpClient
      .post(getAllPromocodesByFilterUrl(), filter, httpOptions);
  }

  deletePromocode(id: number): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${AppCommunicationService.getCurrentUser().access_token}`
      }),
    };

    return this.httpClient
      .delete(getDeletePromocodeUrl(id), httpOptions);
  }

  getAllThesisOrdersByFilter(filter: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${AppCommunicationService.getCurrentUser().access_token}`
      }),
    };

    return this.httpClient
      .post(getAllThesisOrdersByFilterUrl(), filter, httpOptions);
  }

  sendThesisOrderProtocol(thesisOrderId: number, email: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${AppCommunicationService.getCurrentUser().access_token}`,
      }),
    };

    return this.httpClient
      .post(`${getThesisOrderSendProtocolUrl()}`, { email, thesisOrderId }, httpOptions)
      .pipe((res: any) => res);
  }

}
